<template>
    <div>
      <owner-note-form ref="ownerNoteFormModal"></owner-note-form>
      <domainOpposition-owner-form ref="domainOppositionOwnerForm" :getDomainOppositionOwnerList="getDomainOppositionOwnerList"  :domainOppositionId="this.domainOppositionId"></domainOpposition-owner-form>
      <b-row>
        <b-col class="col-12">
          <div style="float:right;" class="custom-search d-flex justify-content-end">
            <b-form-group>
              <div class="d-flex align-items-center">
                <b-button style="float:right;" size="sm" @click="getInfo()" variant="outline-primary"
                  >{{ $t('domainOppositionOwner.add') }}</b-button>
              </div>
            </b-form-group>
          </div>
        </b-col>
      </b-row>
      <!-- table -->
      <vue-good-table 
      id="domainOppositionOwnerTable"
      ref="domainOppositionOwnerTable" 
      :columns="columns" 
      :rows="rows"
      styleClass="vgt-table condensed tableSize"
      :select-options="{
        enabled: false,
        selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
        selectionInfoClass: 'custom-class',
        selectionText: 'rows selected',
        clearSelectionText: 'clear',
        disableSelectInfo: true, // disable the select info panel on top
        selectAllByGroup: true, // when used in combination with a grouped table, add a checkbox in the header row to check/uncheck the entire group
      }" 
        theme="my-theme">
        <div slot="emptystate">
          {{ $t('dataTable.data_not_found') }}
        </div>
        <!-- Row: Table Row -->
        <template slot="table-column" slot-scope="props">
          <span v-if="props.column.field === 'clientName'" class="text-nowrap">
            {{ $t('domainOppositionOwner.name') }}
          </span>
          <span v-else-if="props.column.field === 'process'" class="text-nowrap">
            {{ $t('others.process') }}
          </span>
        </template>
        <!-- Column: Table Column -->
        <template slot="table-row" slot-scope="props">
          <!-- Column: Process -->
          <span v-if="props.column.field === 'process'">
            <span>
              <b-button v-b-tooltip.html :title="$t('domainOppositionOwner.note')" variant="light" class="btn-icon mb-1 ml-1"
                size="sm" @click="getOwnerNoteInfo(props.row.clientId)">
                <feather-icon icon="AlignRightIcon" />
              </b-button>
              <b-button v-b-tooltip.html :title="$t('domainOppositionOwner.show_owner')" variant="info" class="btn-icon mb-1 ml-1"
                  size="sm" @click="getShowOwner(props.row.clientId)">
                  <feather-icon icon="UsersIcon" />
              </b-button>
              <b-button v-b-tooltip.html :title="$t('others.delete')" variant="warning" class="btn-icon mb-1 ml-1"
                size="sm" @click="deleted(props.row)">
                <feather-icon icon="XIcon" />
              </b-button>
            </span>
          </span>
        </template>
      </vue-good-table>
    </div>
  </template>
  
  <script>
  export default {
    props: {
      domainOppositionId: Number,
      getOwnerInfo: {type: Function},
    },
    data() {
      return {
        dir: false,
        columns: [
          {
            label: this.$t('domainOppositionOwner.name') ,
            field: `clientName`,
          },
          {
            label: 'Process',
            field: 'process',
            width: '15em'
          },
        ],
        rows: [],
        searchTerm: '',
      }
    },
    mounted() {
      this.getDomainOppositionOwnerList()
    },
    methods: {
      async getInfo() {
        this.$refs.domainOppositionOwnerForm.showInfo()
      },
      async getOwnerNoteInfo(clientId) {
        this.$refs.ownerNoteFormModal.getNoteListByClientId(clientId)        
      }, 
      async getClientShowInfo(clientAccountingId) {
          this.$refs.ownerFormModal.showInfo(clientAccountingId)
        },
      async getShowOwner(clientId) {
        this.getOwnerInfo(clientId)      
      }, 
      async deleted(data) {
        data = { id: data.id }
        const controller = { name: 'DomainOppositionOwner' }
        const payload = { data: data, controller: controller }
        this.$DeleteConfirm().then(result => {
          if (result.value) {
            this.$store.dispatch('moduleAuth/delete', payload).then((response) => {
              if (response.data.resultStatus == true) {
                this.$DeleteAlert()
                this.getDomainOppositionOwnerList()
              } else {
                this.$WarningAlert(response.data.resultMessage)
                this.getDomainOppositionOwnerList()
              }
            })
          }
        })
      },
      getDomainOppositionOwnerList() {
        this.rows = [] 
        const data = { id: this.domainOppositionId }
        const controller = { name: 'DomainOppositionOwner', actionName:'GetDomainOppositionOwnerListByDomainOppositionId' }
        const payload = { data: data, controller: controller }
        this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
          if (response.data.resultStatus == true) {
            response.data.domainOppositionOwnerList.forEach(element => {
              this.rows.push(element)
            })
          }
          else {
            this.$WarningAlert(response.data.resultMessage)
          }
        }
        )
      },
    },
  }
  </script>
  <style lang="scss" >
    .tableSize {
      font-size: 13px!important;
      border-collapse: collapse;
      width: 100%;
      max-width: 100%;
      table-layout: auto;
  }
  </style>
  